export default __webpack_public_path__ + "static/media/merc_background.f5119d03.jpeg";